import PhoneBookEntryPage from './PhoneBookEntryPage'

export default PhoneBookEntryPage
